export enum CurrencyType {
    Money = "Money",
    Souls = "Souls",
    Wood = "Wood",
    Grain = "Grain",
    Bronze = "Bronze",
    Silver = "Silver",
    Gold = "Gold",
}
